// parse integer values from typoscript settings
if (typeof IgHeadersliderSettings !== "undefined") {
  for (let property in IgHeadersliderSettings) {
    if (IgHeadersliderSettings.hasOwnProperty(property)) {
      let value = IgHeadersliderSettings[property];
      if (!isNaN(value)) {
        IgHeadersliderSettings[property] = parseInt(value);
      }
    }
  }
}

/**
 * Global Settings Object
 * merged with settings from flexform
 * @type object
 */
export const Settings = Object.assign({
  breakpoint: 900
}, IgHeadersliderSettings);
